import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=3dbc4026&scoped=true&"
import script from "./ImageComponent.vue?vue&type=script&lang=js&"
export * from "./ImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&id=3dbc4026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc4026",
  null
  
)

export default component.exports